var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnhancementNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#A0CFDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1569 20.5643H27.7048C27.5558 20.5643 27.4236 20.4657 27.3814 20.322L24.4791 10.7402C24.3835 10.4218 23.9307 10.419 23.8323 10.7374L20.8063 20.3276C20.7613 20.4685 20.6319 20.5643 20.4829 20.5643H10.8396C10.5162 20.5643 10.3755 20.9756 10.6343 21.1728L18.6155 27.2695L16.8494 32.8676L15.5698 36.933C15.4714 37.2486 15.837 37.5078 16.0985 37.3049L23.9167 31.3209L23.9392 31.304L23.9814 31.335L31.9204 37.4289C32.182 37.6289 32.5476 37.3754 32.452 37.0598L29.5272 27.402C29.485 27.2667 29.5328 27.1174 29.6481 27.0329L37.365 21.1728C37.6238 20.9756 37.486 20.5614 37.1597 20.5614L37.1569 20.5643Z",
    stroke: "#0F2A59",
    strokeWidth: 1.50938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhancementNew);
export default __webpack_public_path__ + "static/media/enhancement-new.28b8b59d5f72a6ddcb99fae7f664bcac.svg";
export { ForwardRef as ReactComponent };